
import { Vue, Component, Prop } from 'vue-property-decorator';
import CutoffResultsItem from '@/features/cutoff-times/components/CutoffResultsItem.vue';
import { TransformedCutoffTimesItem } from '@/features/cutoff-times/types';

@Component({
  components: {
    CutoffResultsItem,
  },
})
export default class CutoffResults extends Vue {
  @Prop({ required: true }) items!: TransformedCutoffTimesItem[];
}
